import { render, staticRenderFns } from "./SocialIcon.vue?vue&type=template&id=16f8aa35&scoped=true"
import script from "./SocialIcon.vue?vue&type=script&lang=js"
export * from "./SocialIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f8aa35",
  null
  
)

export default component.exports